import { Controller } from '@hotwired/stimulus'
import intlTelInput from 'intl-tel-input'
import 'intl-tel-input/build/css/intlTelInput.css'

export default class extends Controller {
  static targets = ['input']

  connect () {
    if (!this.inputTarget.dataset.intlTelInputInitialized) {
      this.intlTelInput = intlTelInput(this.inputTarget, {
        loadUtils: () => import('intl-tel-input/build/js/utils'),
        initialCountry: 'us',
        placeholderNumberType: 'MOBILE',
        validationNumberTypes: 'MOBILE',
        strictMode: true,
        nationalMode: true,
        separateDialCode: true,
        autoPlaceholder: 'aggressive'
      })

      this.inputTarget.dataset.intlTelInputInitialized = true
    }
  }
}
// https://intl-tel-input.com/storybook/?path=/docs/intltelinput--strictmode
